import { FC, ReactNode } from 'react';

import { Modal } from '@/shared/design-system';

const MODAL_MAX_WIDTH = 560;

interface ModalShellProps {
  open: boolean;
  onClose: () => void;
  title?: string;
  description?: string;
  children: ReactNode;
}

export const ModalShell: FC<ModalShellProps> = ({
  open,
  onClose,
  title,
  description,
  children,
}) => (
  <Modal
    open={open}
    onOpenChange={(isOpen) => !isOpen && onClose()}
    variant="center"
    maxWidth={MODAL_MAX_WIDTH}
    title={title}
    description={description}
  >
    {children}
  </Modal>
);
